var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTooltipArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#000",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 12.124245,1.7326853 c 0.394693,-0.6021957 1.277247,-0.6025185 1.67234,-6.199e-4 l 8.811894,13.4234876 c 0.43647,0.664838 -0.04025,1.548435 -0.835536,1.548746 l -17.6138661,0.0065 C 3.363768,16.71112 2.8863753,15.827807 3.3223322,15.16266 Z",
    id: "path1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTooltipArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tooltip-arrow.ffa59754f9b97f2a32226d476596cc89.svg";